import React from 'react';

const EmConstrucao = () => {
  return (
    <div style={{ textAlign: 'center', padding: '20px', minHeight: '67vh' }}>
      <h2>Em Construção</h2>
      <p>Esta página ainda está sendo desenvolvida. Volte em breve para ver o conteúdo!</p>
    </div>
  );
};

export default EmConstrucao;
